export default function checkTableImage(value) {
  if (value) {
    return (
      <img
        src={value}
        srcSet={value}
        alt="Asset"
        loading="lazy"
        style={{ objectFit: 'contain', height: 50 }}
      />
    );
  }
  return;
}